import { each } from 'lodash';

export default {

  /**
   * Gets parameter value from url by name
   * @param  {String} name    Name of param
   * @return {String}         Param value
   */
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  /**
   * Appends parameter to given url or gets window.location
   * @param  {String} name  Name of parameter to append
   * @param  {String} value Value of parameter
   * @param  {String} url   Given url
   * @return {String}       Result url
   */
  appendParameter(name, value, url) {
    if (!url) url = window.location.href;
    let arr = url.split('?');
    if (arr.length === 1) {
      return url + '?' + name + '=' + value;
    } else if (arr.length === 2) {
      let params = arr[1].split('&');
      let p = {};
      let a = [];
      let strarr = [];
      each(params, (element, index) => {
        a = element.split('=');
        p[a[0]] = a[1];
      });
      p[name] = value;
      for (let o in p) {
        strarr.push(o + '=' + p[o]);
      }
      let str = strarr.join('&');
      return arr[0] + '?' + str;
    }
  },

  /**
   * Checks if given string represents url
   * @param  {String} url String to check
   * @return {Boolean}    True if url
   */
  validate(url) {
    let hostRE = /^(https?:\/\/)([\da-zA-Z0-9.-]+)(\.[a-zA-Z.]{2,6})?(:\d{1,5})?(.*)?$/;
    return hostRE.test(url);
  }

};



// WEBPACK FOOTER //
// ./src/utils/urlUtils.js